var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesVisaonlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6078 18.3333H4.49283V3.79057H14.6078C15.657 3.79057 16.5075 4.64109 16.5075 5.69023V16.4337C16.5075 17.4828 15.657 18.3333 14.6078 18.3333Z",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49283 3.79047L12.4164 1.73818C13.6737 1.36758 14.9365 2.49289 14.7757 3.79047",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3634 10.2827C14.3634 12.4164 12.6338 14.1461 10.5001 14.1461C8.36647 14.1461 6.63684 12.4164 6.63684 10.2827C6.63684 8.1491 8.36647 6.41943 10.5001 6.41943C12.6338 6.41943 14.3634 8.1491 14.3634 10.2827Z",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1711 6.4506C8.73706 9.30409 8.72589 11.2721 10.1479 14.1143",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8452 14.114C12.2686 11.2671 12.2691 9.29918 10.8364 6.45039",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75146 10.2828H14.2421",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77893 16.2551H8.57243",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6506 16.2551H14.3635",
    stroke: "#707170",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesVisaonlineIcon);
export default __webpack_public_path__ + "static/media/services-visaonline-icon.933d1a8a.svg";
export { ForwardRef as ReactComponent };